import CommonPalette from "../../../core/gd/skin/skin-palette/common-palette";
import {SkinCommonColorPalette} from "../../../core/gd/skin/skin-palette/@type";
import {SkinTheme} from "../@const";

const COMMON_LIGHT: SkinCommonColorPalette = {
    'palette-white'                         : '#FFFFFF',
    'bg-content-plate-on-gray'              : '#FFFFFF',

    // Font colors
    'palette-font-default'                  : '#000000',
    'palette-font-less-important'           : '#161616',
    'palette-font-not-important'            : '#4C4C4C',
    'palette-font-disabled'                 : '#6D6D6D',
    'palette-font-disabled-on-gray'         : '#AEAEAE',
    'palette-font-no-accent'                : '#6D6D6D',
    'palette-font-no-accent-on-gray'        : '#6D6D6D',
    'palette-font-title'                    : '#161616',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#353E4A',
    'palette-font-on-color-bg'              : '#FFFFFF',
    'palette-font-less-important-on-pale'   : '#353E4A',

    // First variant. Color like in "Teams"
    // 'palette-font-text-link'                : '#7a83f0',
    'palette-font-text-link'                : '#0068FF',

    'temp-palette-font-hmenu'               : '#5E6267',

    // Highlight colors

    // First variant. Colors like in "Teams"
    // 'palette-highlight-blue'                : '#f3f2ff',
    // 'palette-highlight-blue-light'          : '#fcfcfe',
    // 'palette-menu-item-hover-color'         : '#fcfcfe',

    'palette-highlight-blue'                : '#ebf3ff',//'#F2FAFF',
    'palette-highlight-blue-light'          : '#FCFDFE',
    'palette-menu-item-hover-color'         : '#f2f5f7',

    // First variant. Colors like in "Teams"
    // 'palette-system-action-dark'            : '#7a83f0',
    // 'palette-system-action'                 : '#7a83f0',
    // 'palette-system-action-light'           : '#7a83f0',

    'palette-system-action-dark'            : '#044AFF', // '#3481FF',
    'palette-system-action'                 : '#1970ff',
    'palette-system-action-light'           : '#598EF8'
}

const COMMON_DARK: SkinCommonColorPalette = {
    'palette-white'                         : '#292929',
    'bg-content-plate-on-gray'              : '#353535',

    // Font colors
    'palette-font-default'                  : '#F7F7F7',
    'palette-font-less-important'           : '#eaeaea',
    'palette-font-not-important'            : '#cacaca',
    'palette-font-disabled'                 : '#787B80',
    'palette-font-disabled-on-gray'         : '#787B80',
    'palette-font-no-accent'                : '#787B80',
    'palette-font-no-accent-on-gray'        : '#BBBBBB',
    'palette-font-title'                    : '#FCFCFC',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#1A222C',
    'palette-font-on-color-bg'              : '#1A222C',
    'palette-font-less-important-on-pale'   : '#000000',

    // First variant. Color like in "Teams"
    // 'palette-font-text-link'                : '#8a95f8',
    'palette-font-text-link'                : '#8ab4f8',

    'temp-palette-font-hmenu'               : '#AEAEAE',

    // Highlight colors

    // First variant. Colors like in "Teams"
    // 'palette-highlight-blue'                : '#393949',
    // 'palette-highlight-blue-light'          : '#393949',
    // 'palette-menu-item-hover-color'         : '#393949',

    'palette-highlight-blue'                : '#2e374a',
    'palette-highlight-blue-light'          : '#232f3c',
    'palette-menu-item-hover-color'         : '#37393d',

    // First variant. Colors like in "Teams"
    // 'palette-system-action-dark'            : '#8a95f8',
    // 'palette-system-action'                 : '#8a95f8',
    // 'palette-system-action-light'           : '#8a95f8',

    'palette-system-action-dark'            : '#3481FF',
    'palette-system-action'                 : '#8ab4f8',
    'palette-system-action-light'           : '#8ab4f8'
}

const DEFAULT_PALETTE = SkinTheme.LIGHT // SkinTheme used like key for palette dictionary

const debug = false
// const debug = "CommonPaletteTeams"

export default class CommonPaletteTeams extends CommonPalette {

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette)

        this.palettes = {
            [SkinTheme.LIGHT]   : COMMON_LIGHT,
            [SkinTheme.DARK]    : COMMON_DARK
        }

        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])

        this.setPalette(this.currentPalette)
    }
}
